<div class="tw:flex tw:flex-col tw:max-w-full">
  <label [class]="allClasses()">
    @if (labelPos() === 'right') {
      <ng-container *ngTemplateOutlet="inputContent()"></ng-container>
      <ng-container *ngTemplateOutlet="labelContent()"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="labelContent()"></ng-container>
      <ng-container *ngTemplateOutlet="inputContent()"></ng-container>
    }
  </label>
  <ng-container *ngTemplateOutlet="validationContent()"></ng-container>
</div>
